module.exports = __webpack_public_path__ + "img/Brian_King@3x.af42cc54.webp";